import { ID } from '../../utils/codecUtils';
import { invokePayloadSchema, invokeResponseSchema } from './invoke.schema';

export type InvokeResponse = unknown;
export type InvokePayload = Record<string, unknown> | undefined;

export const invoke = (id: ID, payload?: InvokePayload) => {
  return {
    endpoint: `/hook_interfaces/${id}/invoke`,
    method: 'POST',
    payload,
    responseSchema: invokeResponseSchema,
    payloadSchema: invokePayloadSchema,
  } as const;
};
